import { useMemo } from 'react';
import { useFlagsService } from '@atlassian/jira-flags';
import {
	IMPORT_PARTIAL_SUCCESS_FLAG_ID,
	IMPORT_IN_PROGRESS_FLAG_ID,
	IMPORT_SUCCESS_FLAG_ID,
} from '@atlassian/jira-project-create-import-progress/src/common/constants';

/* do not want spotlight to interfere with any flags from project create importer */
export const useOverlapsImportFlag = () => {
	const { hasFlag } = useFlagsService();
	const overlapsWithInprogressFlag = hasFlag?.(IMPORT_PARTIAL_SUCCESS_FLAG_ID);
	const overlapsWithPartialSuccessFlag = hasFlag?.(IMPORT_IN_PROGRESS_FLAG_ID);
	const overlapsWithSuccessFlag = hasFlag?.(IMPORT_SUCCESS_FLAG_ID);

	return useMemo(
		() => ({
			overlapsWithImportFlag:
				overlapsWithInprogressFlag || overlapsWithPartialSuccessFlag || overlapsWithSuccessFlag,
		}),
		[overlapsWithInprogressFlag, overlapsWithPartialSuccessFlag, overlapsWithSuccessFlag],
	);
};
